import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

// SVG Logo Component - vertical orientation mirroring header, white blocks with gold accent upper right
const R6Logo = () => (
  <svg width="42" height="60" viewBox="0 0 42 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Top row - 2 boxes */}
    <rect x="0" y="0" width="18" height="18" fill="#FFFFFF" />
    <rect x="21" y="0" width="18" height="18" fill="#C9A227" /> {/* Gold box - upper right */}
    
    {/* Middle row - 2 boxes */}
    <rect x="0" y="21" width="18" height="18" fill="#FFFFFF" />
    <rect x="21" y="21" width="18" height="18" fill="#FFFFFF" />
    
    {/* Bottom row - 2 boxes */}
    <rect x="0" y="42" width="18" height="18" fill="#FFFFFF" />
    <rect x="21" y="42" width="18" height="18" fill="#FFFFFF" />
  </svg>
);

const Footer = () => {
  const navigate = useNavigate();

  const handleNavClick = (path, hash) => {
    if (path) {
      navigate(path);
    } else if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Logo and Description */}
          <div className="footer-column">
            <div className="footer-logo">
              <R6Logo />
            </div>
            <p className="footer-description">
              Strategic talent solutions for small and midsized businesses, franchises, civic organizations, and nonprofits.
            </p>
          </div>

          {/* Company Links */}
          <div className="footer-column">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><a onClick={() => handleNavClick(null, '#about')}>About Us</a></li>
              <li><a onClick={() => navigate('/the-right-path')}>The Right Path</a></li>
              <li><a onClick={() => navigate('/capabilities')}>Capabilities</a></li>
              <li><a onClick={() => handleNavClick(null, '#approach')}>Our Approach</a></li>
            </ul>
          </div>

          {/* Services Links */}
          <div className="footer-column">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><a onClick={() => handleNavClick(null, '#framework')}>Right 6™ Framework</a></li>
              <li><a onClick={() => handleNavClick(null, '#challenges')}>Challenges We Solve</a></li>
              <li><a onClick={() => navigate('/assessment')}>Assessment</a></li>
              <li><a onClick={() => window.open('https://form.jotform.com/260186646305054', '_blank')}>Consultation</a></li>
            </ul>
          </div>

          {/* Resources Links */}
          <div className="footer-column">
            <h4 className="footer-heading">Get Started</h4>
            <ul className="footer-links">
              <li><a onClick={() => navigate('/assessment')}>Take Assessment</a></li>
              <li><a onClick={() => window.open('https://form.jotform.com/260186646305054', '_blank')}>Schedule Call</a></li>
              <li><a onClick={() => window.open('https://form.jotform.com/260155110017036', '_blank')}>Become Affiliate</a></li>
              <li><a onClick={() => navigate('/press')}>Press Kit</a></li>
              <li><a onClick={() => navigate('/sponsorship')}>Sponsorship Kit</a></li>
              <li><a onClick={() => navigate('/portal/login')} data-testid="footer-client-login">Client Login</a></li>
              <li><a onClick={() => navigate('/portal/signup')} data-testid="footer-client-signup">Client Sign Up</a></li>
              <li><a onClick={() => window.open('https://form.jotform.com/260186646305054', '_blank')}>Contact Us</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-text">
            © {new Date().getFullYear()} The R6™ Collective. All rights reserved.
          </p>
          <div className="footer-legal">
            <a href="#">Privacy Policy</a>
            <span className="footer-divider">·</span>
            <a href="#">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;